import SytemAdmin from  '@/components/page/SystemAdmin';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router'


class UserUploadPortal extends Component {
  render() {

    // Container ref
    let targetContainer = document.getElementById('react-system-admin-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
      <Router>
        <SytemAdmin />
      </Router>, targetContainer
    );
  }
}

export default UserUploadPortal;